<div class="mt-2">
  <h3>{{ props.headlineWrapperText || props.label }}</h3>
  <ng-container #fieldComponent></ng-container>
</div>
